// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "client/" + "wix-cashier-express-checkout-widget-dist-src-demo" + ".chunk.min.css";
};